import { http } from "../../../../services";

export const onLogin: producer = async ({
    isLoginSubmited = observe.views[prop._viewId].isLoginSubmited,
    ssn = get.ssn,
    telephone = get.telephone,
    signingMethod = get.signingMethod,
    langId = get.langId
}) => {

    if(!isLoginSubmited){
        return;
    }

    const vesecureData = signingMethod.value() === 'bankid-no' ? {
        ssn: ssn.value(),
        signingMethod: signingMethod.value(),
        metadata: { "ui-module": "recipient-dashboard" },
        langId: langId.value()
    } : signingMethod.value() === 'sms' ? {
        telephone: telephone.value(),
        signingMethod: signingMethod.value(),
        metadata: { "ui-module": "recipient-dashboard" },
        langId: langId.value()
    } : {
        signingMethod: signingMethod.value(),
        metadata: { "ui-module": "recipient-dashboard" },
        langId: langId.value(),
    };

    const res = await http({
      method: "POST",
      url: `/api/recipient-dashboard/vesecure`,
      data: vesecureData,
    });

    const secureUrl = res.data.url;
    console.log("secureUrl: ", secureUrl);
    console.log("Login was submited");
    console.log("Authentication initialized, calling ve-secure");
    window.location.href = secureUrl;
};
